import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useStatus } from "../../status/Status"
import StatusDetailView from './StatusDetailView'

const StatusEdit = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let {
        name, setName,
        remindTimeInDays, setRemindTimeInDays,
    } = useStatus(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.status !== undefined && !permissions.status) {
            toast.error("You don't have permission to edit statuses!")
            navigate("/")
        }
    }, [permissions])

    return <StatusDetailView id={id}
        name={name} setName={setName}
        remindTimeInDays={remindTimeInDays} setRemindTimeInDays={setRemindTimeInDays}
    />
}

export default StatusEdit